import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    styleUrl: './text-area.component.scss',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextAreaComponent),
            multi: true
        }],
    standalone: false
})
export class TextAreaComponent implements ControlValueAccessor {

  @Input() id: string = '';
  @Input("value") _value?: string;
  @Input() placeholder?: string = "";
  @Input() limit?: number =  1000;
  @Input() disabled: boolean = false;
  @Input() displayCharactersCount: boolean = true;
  @Input() rows: number = 3;

  constructor(private cdr: ChangeDetectorRef) {}

  onChange: (value: string) => void = () => {};
  onTouched: any = () => { };

  get value(): string | undefined {
    return this._value;
  }

  set value(val: string) {
    this._value = val;
    this.onChange(val);
    //this.cdr.markForCheck();
  }

  // Called by parent component to set value programatically.
  writeValue(obj: string): void {
    this._value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
